
export const global = `
  * {
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  body{
    font-family: sans-serif;
    color: #333;
  }
  a{
    text-decoration: none;
  }
  li{
    list-style:none;
  }
  pre{
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #f36d33;
    color: #666;
    page-break-inside: avoid;
    font-family: monospace;
    font-size: 12px;
    line-height: 1.6;
    max-width: 100%;
    width:80%;
    margin:10px auto;
    overflow: auto;
    padding: 1em 1.5em;
    word-wrap: break-word;
  }
  html {
    scroll-behavior: smooth;
  }
  button {
    border: 0;
    outline: 0;
    cursor: pointer;
  }
`;
